/**
 * Nos ayuda a comprobar si es un atlas propio de Phaser
 */
const isPhaserAtlas = (data: string): boolean => {
    let isAtlas = false;
    try {
        JSON.parse(data);
        isAtlas = true;
    } catch (error) {
        isAtlas = false;
    }

    if(isAtlas) {
        const have_frames = (data.search('frames') !== -1);
        const have_frame = (data.search('frame') !== -1);
        const have_filename = (data.search('filename') !== -1);
        if(!have_filename || !have_frame || !have_frames) {
            isAtlas = false;
        } else {
            isAtlas = true;
        }
    }
    return isAtlas;
}

export default isPhaserAtlas;